import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import { Tag as LionTag, LightBox } from '@lion-design/core';
import { RootState } from '@Redux/detail/store';
import * as Icons from '@components/Common/Icons';
import * as Tag from '@components/Common/Tag';
import BubbleBox from '@components/Common/BubbleBox';
import GroupDetailSki from '@components/DetailPage/GroupDetailSki';
import GroupNotesCansold from '@components/DetailPage/GroupNotesCansold';
import { defaultImg43 } from '@utils/defaultImg';
import { useTranslation } from 'react-i18next';
import styles from '../style.module.scss';
import { getWeekday } from '@utils/utils';

function Info() {
    const Group = useSelector((store: RootState) => store.groupReducer);

    const [isSkiOpen, setIsSkiOpen] = useState<boolean>(false);
    const [isEnsureOpen, setIsEnsureOpen] = useState<boolean>(false);
    const [isQuotaOpen, setIsQuotaOpen] = useState<boolean>(false);
    const { t } = useTranslation();

    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    return (
        <div className={styles['info-wrapper']}>
            <div className={styles['info-imgs']}>
                {Group.GroupInfo.NormGroupImg ? (
                    <img
                        src={Group.GroupInfo.NormGroupImg}
                        onError={(e: React.SyntheticEvent<HTMLImageElement>) =>
                            ((e.target as HTMLImageElement).src = defaultImg43)
                        }
                        alt={Group.GroupInfo.TourName}
                    />
                ) : (
                    <img src={defaultImg43} alt={Group.GroupInfo.TourName} />
                )}
            </div>
            <div>
                {Group.CheckCruiseInfo && (
                    <div className={styles['tags']}>
                        <Tag.Featured text="郵輪優先選房號" />
                    </div>
                )}
                <ul className={styles.infos}>
                    <li className={styles['type']}>行程{Group.TourIndex}</li>
                    <li>
                        <span className={styles['sub-title']}>{t('GroupID')}</span>
                        <span className={styles.content}>{Group.GroupInfo.GroupID}</span>
                        {Group.GroupInfo.IsEnsureGroup && (
                            <LionTag
                                className={cN(styles.tag, styles.ensure)}
                                onClick={isMobile ? () => setIsEnsureOpen(true) : undefined}
                            >
                                {isMobile ? (
                                    <>
                                        {t('IsEnsureGroup')}
                                        <span onClick={() => setIsEnsureOpen(true)}>
                                            <Icons.Info fill="#ff5a00" />
                                        </span>
                                    </>
                                ) : (
                                    <BubbleBox content={<IsEnsureGroupContent />}>
                                        {t('IsEnsureGroup')}
                                        <Icons.Info fill="#ff5a00" />
                                    </BubbleBox>
                                )}
                            </LionTag>
                        )}
                    </li>
                    <li className={styles.seats}>
                        <span className={styles['sub-title']}>可賣</span>
                        <span className={styles.content}>{Group.GroupInfo.QuotaSeats}</span>
                        <span className={cN(styles['sub-title'], styles.all)}>{t('seats')}</span>
                        <span className={styles.content}>{Group.GroupInfo.TotalSeats}</span>
                        {isMobile && (
                            <span
                                className={styles['seats_icon']}
                                onClick={isMobile ? () => setIsQuotaOpen(true) : undefined}
                            >
                                <Icons.Info />
                            </span>
                        )}
                    </li>
                    <li>
                        <span className={styles['sub-title']}>去程</span>
                        <span className={styles.content}>{getWeekday(Group.GroupInfo.GoDate)}</span>
                        <span className={cN(styles.content, styles.days)}>
                            共{Group.GroupInfo.TourDays}天
                        </span>
                    </li>
                    <li>
                        <span className={styles['sub-title']}>回程</span>
                        <span className={styles.content}>
                            {getWeekday(Group.GroupInfo.BackDate)}
                        </span>
                    </li>
                    <li className={styles['info-link']}>
                        <a
                            className={styles.link}
                            href={Group.CreditCardUrl}
                            target="_blank"
                            rel="noreferrer noopener"
                        >
                            刷卡好康
                        </a>
                        {Group.CheckCruiseInfo && (
                            <a
                                className={styles.link}
                                href={Group.CruiseRoomUrl}
                                target="_blank"
                                rel="noreferrer noopener"
                            >
                                看艙房
                            </a>
                        )}
                        {Group.GroupInfo.ThemeID.includes('5') && (
                            <div className={styles.link} onClick={() => setIsSkiOpen(!isSkiOpen)}>
                                滑雪報名現狀
                            </div>
                        )}
                    </li>
                </ul>
            </div>
            {/* 光箱 */}
            <GroupDetailSki open={isSkiOpen} ToggleLightBox={() => setIsSkiOpen(false)} />
            <LightBox
                title={`${t('IsEnsureGroup')}說明`}
                className={styles.isEnsureGroup}
                open={isEnsureOpen}
                ToggleLightBox={() => setIsEnsureOpen(false)}
            >
                <IsEnsureGroupContent />
            </LightBox>
            <LightBox
                title={`可賣${t('seats')}說明`}
                className={styles.isQuotaSeats}
                open={isQuotaOpen}
                ToggleLightBox={() => setIsQuotaOpen(false)}
            >
                <GroupNotesCansold />
            </LightBox>
        </div>
    );
}

export default Info;

function IsEnsureGroupContent() {
    const { t } = useTranslation();

    return (
        <div>
            本公司「已{t('IsEnsureGroup')}
            」之旅遊團體，係指報名{t('numberOfAttendee')}
            已達{t('setOff')}
            標準，但團體出發前若遇有以下情事，將依
            {t('standardFormContract')}取消
            {t('setOff')}：
            <br />
            <br />
            一、不可抗力、不可歸責於雙方當事人之事由，如颱風、海嘯、地震、洪災等不可抗力之天然災害；或罷工、戰亂抗爭、官方封閉旅遊地區、重大疫情等不可歸責之人為因素。
            <br />
            <br />
            二、「已{t('IsEnsureGroup')}
            」之旅遊團體所遊覽地區或國家，經外交部領事事務局或交通部觀光局或其他官方單位列為橙色警示、或紅色警示。
        </div>
    );
}
